import { render, staticRenderFns } from "./UpcomingFixturesWidgetEfl.vue?vue&type=template&id=1ca14aee&scoped=true"
import script from "./UpcomingFixturesWidgetEfl.vue?vue&type=script&lang=js"
export * from "./UpcomingFixturesWidgetEfl.vue?vue&type=script&lang=js"
import style0 from "./UpcomingFixturesWidgetEfl.vue?vue&type=style&index=0&id=1ca14aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca14aee",
  null
  
)

export default component.exports